import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './three-pack.less';

// Abacus: HA_PULSE_SKELETON_ABC
import {SkeletonLoading} from '../../abacus/skeleton-abc';

class ThreePack extends Component {
    static propTypes = {
        image1: PropTypes.string,
        image2: PropTypes.string,
        image3: PropTypes.string
    }

    render() {
        const {image1, image2, image3, isLoading} = this.props;
        return (
            <div className="three-pack">
                <div className="three-pack__grid">
                    <div className="three-pack__column">
                        <SkeletonLoading loading={isLoading}>
                            <div className="three-pack__image three-pack__image--rounded-top-and-bottom-left three-pack__image--left-panel" style={(image1 ? {backgroundImage: `url(${image1})`} : {})} />
                        </SkeletonLoading>
                    </div>
                    <div className="three-pack__separator" />
                    <div className="three-pack__column">
                        <SkeletonLoading loading={isLoading}>
                            <div className="three-pack__image three-pack__image--rounded-top-right" style={(image2 ? {backgroundImage: `url(${image2})`} : {})} />
                        </SkeletonLoading>
                            <div className="three-pack__separator" />
                        <SkeletonLoading loading={isLoading}>
                            <div className="three-pack__image three-pack__image--rounded-bottom-right" style={(image3 ? {backgroundImage: `url(${image3})`} : {})} />
                        </SkeletonLoading>
                    </div>
                </div>
            </div>
        );
    }
}

export default ThreePack;



// WEBPACK FOOTER //
// ./src/universal/tripboard/components/three-pack.js